
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('products', { comparison: 'getComparison', mortgage: 'get' }),
      ...mapGetters('search', { search: 'get' }),
      featureNotes () {
        return ['first_time_buyer', 'buy_to_let', 'new_property', 'new_customer',
                'existing_customer', 'switcher_mortgage'].map((note) => {
                  return this.mortgage[`${note}`] && this.mortgage[`${note}_note`];
                }).filter(Boolean);
      }
    }
  };
